import { Phone } from "lucide-react";
import { BookLink, PHONE_TEL } from "./booking";

export default function MobileBar() {
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden grid grid-cols-2 border-t border-border bg-background/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]"
    >
      <BookLink
        testid="mobile-bar-book-button"
        className="flex items-center justify-center bg-primary text-primary-foreground font-bold text-sm tracking-[0.18em] uppercase py-4"
      >
        Book Now
      </BookLink>
      <a
        href={PHONE_TEL}
        data-testid="mobile-bar-call-button"
        className="flex items-center justify-center gap-2 text-foreground font-bold text-sm tracking-[0.18em] uppercase py-4 border-l border-border"
      >
        <Phone size={16} aria-hidden="true" /> Call Now
      </a>
    </div>
  );
}
